import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { BILLING_API } from '@Constants/backendConstants';
import { initialInvoiceSnapshotSorting, invoiceSnapshotColumns } from '@Constants/TableColumns';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { ApiInvoiceSnapshot, EnumFrontendLayoutSetting } from '@Model';
import { useTableRefetch } from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import type { IInvoiceSnapshotViewProps } from './invoiceSnapshotListProps';
import { usePagedListApi } from '@Hooks/useListApi';
import { InvoiceSnapshotsRepository } from '@Repositories/Billing';

interface IFrameListAllInvoiceSnapshotsProps extends IInvoiceSnapshotViewProps {}

export function FrameListAllInvoiceSnapshots({
    objectSelector,
    onLoaderDone,
    toolbarElements,
    rowActionsColumn,
}: IFrameListAllInvoiceSnapshotsProps) {
    const { refetchRef, refetchTable } = useTableRefetch();
    useRemoteCacheInvalidation('invoice_snapshots', refetchTable);

    const module = usePagedListApi(InvoiceSnapshotsRepository, BILLING_API);

    const columns = useMemo(
        () => (rowActionsColumn === undefined ? invoiceSnapshotColumns : [...invoiceSnapshotColumns, rowActionsColumn]),
        [rowActionsColumn],
    );

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiInvoiceSnapshot>
            layoutSettingsContext={EnumFrontendLayoutSetting.InvoiceSnapshotsTableLayout}
            name="InvoiceSnapshotList"
            columns={columns}
            loader={module.loadPage}
            onLoaderDone={onLoaderDone}
            refetchRef={refetchRef}
            initialSorting={initialInvoiceSnapshotSorting}
            canCreate={false}
            objectSelector={objectSelector}
            toolbarElements={toolbarElements}
            useOnClickNavigation
            fullSize
        />
    );
}
